/* 5ive — interactions du thème Shopify. Aucune dépendance. */
(() => {
  'use strict';

  /* ------------------------------------------------------------------
     CONFIG — tout ce qui dépend de vraies données se règle ici.
     ------------------------------------------------------------------ */
  // Réglages injectés par le thème (layout/theme.liquid → window.FIVE) : variantes du produit,
  // clé Google, URLs. Les prix viennent de Shopify : on ne les recopie pas ici.
  const F = window.FIVE || {};
  const packs = (F.variants || []).map(v => ({
    n: parseInt(String(v.option1 || v.title).match(/\d+/), 10) || 1,
    price: v.price / 100, id: v.id, available: v.available,
  })).sort((x, y) => x.n - y.n);
  const best = packs.filter(p => p.n > 1).sort((x, y) => x.price / x.n - y.price / y.n)[0];
  if (best) best.badge = 'Meilleur prix';
  const CONFIG = {
    product: { unitPrice: (packs.find(p => p.n === 1) || packs[0] || { price: 0 }).price, currency: F.currency || 'EUR' },
    packs,
    googleMapsKey: F.googleMapsKey || '',
    placesRegions: ['fr', 'be', 'ch', 'lu'],
    networkThreshold: 10,
    leadEndpoint: '',
    contactEmail: '',
    img: F.img || {},
    urls: F.urls || { product: '/' },
    showPlaceholders: false,
  };

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const euro = n => n.toLocaleString('fr-FR', { style: 'currency', currency: CONFIG.product.currency });
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const params = new URLSearchParams(location.search);

  if ((CONFIG.showPlaceholders && !params.has('final')) || params.has('verifier')) document.body.classList.add('show-placeholders');

  /* Variante de titre à tester : ?h=b */
  if (params.get('h') === 'b') {
    const t = $('[data-headline]');
    if (t) t.innerHTML = 'Le chemin le plus court<br> vers 5 étoiles.';
  }

  /* ------------------------------------------------------------------ header */
  const header = $('.header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 8);
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const menuBtn = $('.menu-btn');
  const menu = $('.menu');
  if (menuBtn && menu) {
    const setMenu = open => {
      menu.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
    };
    menuBtn.addEventListener('click', () => setMenu(!menu.classList.contains('is-open')));
    $$('a', menu).forEach(a => a.addEventListener('click', () => setMenu(false)));
    addEventListener('keydown', e => e.key === 'Escape' && setMenu(false));
  }

  /* ------------------------------------------------------------------ reveal */
  const revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealEls.forEach(el => io.observe(el));
  } else revealEls.forEach(el => el.classList.add('is-in'));

  /* ------------------------------------------------------------------ démo hero : joue seulement si visible */
  $$('.demo').forEach(demo => {
    if (reduceMotion) return;
    demo.classList.add('is-playing');
    const io = new IntersectionObserver(([e]) => demo.classList.toggle('is-paused', !e.isIntersecting), { threshold: .15 });
    io.observe(demo);
    document.addEventListener('visibilitychange', () => demo.classList.toggle('is-paused', document.hidden));
  });

  /* ------------------------------------------------------------------ panier (panier Shopify, API AJAX)
     Une ligne = un pack (variante du produit). Chaque plaque est reliée à une fiche Google précise :
     les établissements partent en propriétés de ligne, visibles dans la commande Shopify. */
  const PICK = '5ive-pick';
  const esc = v => String(v ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k, fb, s = localStorage) { try { return JSON.parse(s.getItem(k)) ?? fb; } catch { return fb; } },
    set(k, v, s = localStorage) { try { s.setItem(k, JSON.stringify(v)); } catch {} },
    del(k, s = localStorage) { try { s.removeItem(k); } catch {} },
  };
  const reviewUrl = id => `https://search.google.com/local/writereview?placeid=${encodeURIComponent(id)}`;
  const placeKey = p => p.placeId || `${p.name}|${p.postcode || ''}`.toLowerCase();
  const packOf = n => CONFIG.packs.find(p => p.n === n);
  const money = cents => euro(cents / 100);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // regroupe les plaques identiques : [{ place, count }]
  const groupPlaces = places => places.reduce((acc, p) => {
    const g = acc.find(x => placeKey(x.place) === placeKey(p));
    g ? g.count++ : acc.push({ place: p, count: 1 });
    return acc;
  }, []);

  let cart = { items: [], item_count: 0, total_price: 0 };
  const plaquesOf = item => (CONFIG.packs.find(p => p.id === item.variant_id) || { n: 1 }).n * item.quantity;

  // relit les établissements depuis les propriétés de ligne (« Établissement », « Établissement 2 »…)
  const placesOf = item => {
    const pr = item.properties || {};
    return Object.keys(pr).filter(k => /^Établissement( \d+)?$/.test(k)).map(k => {
      const sfx = k.slice('Établissement'.length);
      const count = parseInt(pr[`Plaques${sfx}`], 10) || null;
      return { name: pr[k], address: pr[`Adresse${sfx}`] || '', ok: !!pr[`_Lien avis Google${sfx}`], count };
    });
  };

  const drawer = $('.drawer');
  const scrim = $('.drawer-scrim');
  let lastFocus = null;

  const lineHTML = (item, i) => {
    const n = plaquesOf(item) / item.quantity;
    const places = placesOf(item);
    return `
    <div class="line" data-i="${i}">
      <div class="line__img">${n > 1 ? `<span class="line__n">×${n}</span>` : ''}<img src="${CONFIG.img.plaque}" alt="" width="600" height="614"></div>
      <div>
        <div class="line__top"><span>${n === 1 ? esc(item.product_title) : `Pack ${n} plaques`}${item.quantity > 1 ? ` × ${item.quantity}` : ''}</span><span class="price">${money(item.final_line_price)}</span></div>
        <ul class="line__places">${places.map(p => `
          <li><b>${p.count && n > 1 ? `${p.count} × ` : ''}${esc(p.name)}</b>${p.address ? `<span>${esc(p.address)}</span>` : ''}
          ${p.ok ? '<em class="line__ok">Fiche Google trouvée</em>' : '<em class="line__meta">Saisie manuelle · on vérifie avec vous</em>'}</li>`).join('')}
        </ul>
        <div class="line__ctrl"><span></span><button type="button" class="line__rm" data-l="rm">Retirer</button></div>
      </div>
    </div>`;
  };

  const render = () => {
    const qty = cart.items.reduce((n, it) => n + plaquesOf(it), 0);
    $$('.cart-count').forEach(el => {
      el.textContent = qty;
      el.classList.toggle('has-items', qty > 0);
    });
    $$('[data-cart-label]').forEach(el => el.setAttribute('aria-label', qty ? `Panier, ${qty} plaque${qty > 1 ? 's' : ''}` : 'Panier vide'));
    if (!drawer) return;
    $('.drawer__filled', drawer).hidden = qty === 0;
    $('.drawer__empty', drawer).hidden = qty > 0;
    $('.drawer__foot', drawer).hidden = qty === 0;
    $('[data-lines]', drawer).innerHTML = cart.items.map(lineHTML).join('');
    $('[data-subtotal]', drawer).textContent = money(cart.total_price);
    $('.drawer__nudge', drawer).hidden = qty < 5;
  };

  const bump = () => $$('.cart-count').forEach(el => { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
  const api = (path, body) => fetch(`${root}${path}`, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'cart'); return j; });
  const refresh = () => api('cart.js').then(c => { cart = c; render(); }).catch(() => {});

  /* propriétés de ligne envoyées à Shopify (le « _ » les cache au client, pas à vous) */
  const placeAttrs = (p, sfx = '') => {
    const a = { [`Établissement${sfx}`]: p.name };
    if (p.address) a[`Adresse${sfx}`] = p.address;
    if (p.placeId) {
      a[`_Lien avis Google${sfx}`] = reviewUrl(p.placeId);
      a[`_Google Place ID${sfx}`] = p.placeId;
    } else a[`_À vérifier${sfx}`] = 'Saisie manuelle, fiche Google à confirmer';
    if (p.mapsUrl) a[`_Fiche Google Maps${sfx}`] = p.mapsUrl;
    return a;
  };
  const lineProperties = (pack, places) => {
    const groups = groupPlaces(places);
    if (groups.length === 1) return { Plaques: `${pack} pour le même établissement`, ...placeAttrs(groups[0].place) };
    return Object.assign({}, ...groups.map((g, i) => ({ [`Plaques ${i + 1}`]: String(g.count), ...placeAttrs(g.place, ` ${i + 1}`) })));
  };

  const addLine = async (pack, places) => {
    const p = packOf(pack);
    await api('cart/add.js', { items: [{ id: p.id, quantity: 1, properties: lineProperties(pack, places) }] });
    await refresh();
    bump();
  };

  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(() => $('.drawer__close', drawer).focus(), 60);
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    lastFocus && lastFocus.focus();
  };

  // Tous les boutons « ajouter » mènent au configurateur (il faut un établissement).
  const goConfigure = () => {
    const conf = $('#commander');
    if (!conf) { location.href = `${CONFIG.urls.product}#commander`; return; }
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    conf.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  };
  $$('[data-add]').forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); goConfigure(); }));
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openDrawer(); }));
  scrim && scrim.addEventListener('click', closeDrawer);
  drawer && $('.drawer__close', drawer).addEventListener('click', closeDrawer);
  addEventListener('keydown', e => { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });

  if (drawer) {
    // piège de focus simple
    drawer.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const f = $$('button:not([disabled]), a[href], input', drawer).filter(el => el.offsetParent);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    });
    $('[data-lines]', drawer).addEventListener('click', e => {
      const b = e.target.closest('[data-l=rm]'); if (!b) return;
      b.disabled = true;
      api('cart/change.js', { line: +b.closest('.line').dataset.i + 1, quantity: 0 }).then(c => { cart = c; render(); }).catch(refresh);
    });
    $('[data-checkout]', drawer).addEventListener('click', () => { location.href = `${root}checkout`; });
  }
  refresh();

  /* ------------------------------------------------------------------ recherche d'établissement Google */
  const Places = (() => {
    let lib = null;
    // ?mock : résultats fictifs pour tester le parcours en local, sans clé Google.
    const mock = params.has('mock') && /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
    const MOCK = [
      { placeId: 'DEMO-1', name: 'Établissement de démo', address: '1 rue de l’Exemple, 75000 Paris, France' },
      { placeId: 'DEMO-2', name: 'Établissement de démo 2', address: '2 avenue Fictive, 69000 Lyon, France' },
    ];
    const load = () => lib || (lib = new Promise((ok, ko) => {
      if (!CONFIG.googleMapsKey) return ko(new Error('no-key'));
      window.__5ivePlaces = () => google.maps.importLibrary('places').then(ok, ko);
      const s = document.createElement('script');
      s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(CONFIG.googleMapsKey)}&loading=async&language=fr&callback=__5ivePlaces`;
      s.async = true; s.onerror = () => ko(new Error('load'));
      document.head.append(s);
    }));
    return {
      enabled: mock || !!CONFIG.googleMapsKey,
      async suggest(input, session) {
        if (mock) return MOCK.map(m => ({ id: m.placeId, main: m.name, sub: m.address, get: async () => m }));
        const { AutocompleteSuggestion } = await load();
        if (!session.token) session.token = new (await load()).AutocompleteSessionToken();
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input, sessionToken: session.token, language: 'fr', region: 'fr', includedRegionCodes: CONFIG.placesRegions,
        });
        return suggestions.filter(s => s.placePrediction).slice(0, 5).map(({ placePrediction: p }) => ({
          id: p.placeId, main: p.mainText?.text || p.text.text, sub: p.secondaryText?.text || '',
          get: async () => {
            const place = p.toPlace();
            await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'googleMapsURI'] });
            session.token = null; // la sélection clôt la session de facturation
            return { placeId: place.id, name: place.displayName || p.mainText?.text, address: place.formattedAddress || '', mapsUrl: place.googleMapsURI || '' };
          },
        }));
      },
    };
  })();

  const FINDER_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.2-4.2"/></svg>';
  let finderN = 0;

  // Monte le composant dans chaque [data-finder] : une seule barre de recherche, comme chez Digifeel.
  // Le client choisit son établissement dans les suggestions Google, ou tape simplement son nom et sa ville
  // (le texte saisi est alors gardé tel quel et vérifié par nous). onPick(place|null, saisieLibre) à chaque changement.
  const mountFinder = (root, onPick) => {
    const n = ++finderN, home = root.dataset.finder === 'home';
    root.classList.add('finder');
    const gMode = 'g' in root.dataset; // champ façon Digifeel : logo Google, sans libellé
    if (gMode) root.classList.add('finder--g');
    const ph = root.dataset.placeholder || (gMode ? 'Exemple : Boulangerie Martin, Dunkerque' : 'Nom de l’établissement, ville…');
    root.innerHTML = `
      <div class="finder__search">
        <label class="finder__label" for="fq${n}">${esc(root.dataset.label || 'Trouvez votre établissement')}</label>
        <div class="finder__box">
          ${FINDER_ICON}
          <input class="finder__input" id="fq${n}" type="text" autocomplete="off" spellcheck="false" enterkeyhint="search"
            placeholder="${esc(ph)}" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="fl${n}">
          <span class="finder__g" aria-hidden="true"><svg class="finder__glogo" viewBox="0 0 48 48" width="22" height="22"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg></span>
          <ul class="finder__list" id="fl${n}" role="listbox" hidden></ul>
        </div>
      </div>
      <div class="finder__picked" hidden>
        <span class="finder__pin" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 21s-6.5-5.6-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.3"/></svg></span>
        <span class="finder__picked-txt"><b></b><span></span></span>
        <button type="button" class="finder__change" data-f="change">Modifier</button>
      </div>`;

    const q = $('.finder__input', root), list = $('.finder__list', root);
    const search = $('.finder__search', root), picked = $('.finder__picked', root);
    const session = {};
    let results = [], active = -1, timer, seq = 0, current = null;

    const closeList = () => { list.hidden = true; q.setAttribute('aria-expanded', 'false'); q.removeAttribute('aria-activedescendant'); active = -1; };
    const setActive = i => {
      active = i;
      $$('li', list).forEach((li, j) => li.setAttribute('aria-selected', String(j === i)));
      if (i >= 0) q.setAttribute('aria-activedescendant', `fl${n}-${i}`);
    };
    const setPicked = place => {
      current = place;
      search.hidden = !!place; picked.hidden = !place;
      if (place) {
        $('b', picked).textContent = place.name;
        $('.finder__picked-txt span', picked).textContent = place.address || '';
      }
      onPick && onPick(place, false);
    };
    // saisie libre : le texte tapé suffit (nom + ville), tant qu'aucune suggestion n'est choisie
    const readTyped = () => {
      const v = q.value.trim();
      current = v.length >= 3 ? { name: v, manual: true } : null;
      onPick && onPick(current, true);
    };

    const run = async () => {
      const v = q.value.trim(), my = ++seq;
      if (!Places.enabled || v.length < 2) { closeList(); return; }
      try {
        const r = await Places.suggest(v, session);
        if (my !== seq) return;
        results = r;
        list.innerHTML = r.length
          ? r.map((s, i) => `<li id="fl${n}-${i}" role="option" aria-selected="false"><b>${esc(s.main)}</b><span>${esc(s.sub)}</span></li>`).join('')
          : '<li class="finder__none" role="presentation">Pas de résultat ? Écrivez simplement le nom et la ville : on s’occupe du reste.</li>';
        list.insertAdjacentHTML('beforeend', '<li class="finder__by" role="presentation" aria-hidden="true">powered by <b>Google</b></li>');
        list.hidden = false; q.setAttribute('aria-expanded', 'true'); setActive(-1);
      } catch { closeList(); }
    };
    const choose = async i => {
      const s = results[i]; if (!s) return;
      closeList();
      q.disabled = true;
      try { setPicked(await s.get()); }
      catch { setPicked({ placeId: s.id, name: s.main, address: s.sub }); }
      q.disabled = false;
    };

    q.addEventListener('input', () => { readTyped(); clearTimeout(timer); timer = setTimeout(run, 220); });
    q.addEventListener('keydown', e => {
      const len = results.length;
      if (e.key === 'ArrowDown' && !list.hidden && len) { e.preventDefault(); setActive((active + 1) % len); }
      else if (e.key === 'ArrowUp' && !list.hidden && len) { e.preventDefault(); setActive((active - 1 + len) % len); }
      else if (e.key === 'Enter') { e.preventDefault(); if (!list.hidden && len) choose(active < 0 ? 0 : active); }
      else if (e.key === 'Escape') closeList();
    });
    list.addEventListener('mousedown', e => e.preventDefault());
    list.addEventListener('click', e => { const li = e.target.closest('li[role=option]'); li && choose($$('li', list).indexOf(li)); });
    q.addEventListener('blur', () => setTimeout(closeList, 120));
    root.addEventListener('click', e => {
      if (!e.target.closest('[data-f=change]')) return;
      setPicked(null); search.hidden = false; picked.hidden = true; q.value = ''; q.focus();
    });

    return {
      get: () => current,
      set: p => setPicked(p),
      reset: () => { q.value = ''; current = null; results = []; closeList(); search.hidden = false; picked.hidden = true; },
      focus: () => q.focus(),
      typed: () => q.value.trim(),
      prefill: name => { q.value = name; readTyped(); run(); },
      home,
    };
  };

  /* accueil : trouver son établissement puis passer à la commande */
  $$('[data-finder="home"]').forEach(root => {
    const f = mountFinder(root, (place, manual) => {
      if (place && !manual) { store.set(PICK, place, sessionStorage); location.href = `${CONFIG.urls.product}#commander`; }
    });
    const go = root.parentElement.querySelector('[data-finder-go]');
    go && go.addEventListener('click', e => {
      e.preventDefault();
      const p = f.get(), name = f.typed();
      if (p) store.set(PICK, p, sessionStorage);
      else if (name) store.set(PICK, { prefillName: name }, sessionStorage);
      location.href = `${CONFIG.urls.product}#commander`;
    });
  });

  /* ------------------------------------------------------------------ configurateur page produit
     Comme chez Digifeel : une offre (nombre de plaques), un nombre d'emplacements (établissements),
     puis une recherche Google par emplacement. Avec plusieurs emplacements, le client répartit ses plaques. */
  const conf = $('[data-configurator]');
  if (conf) {
    const err = $('.conf__err', conf);
    const cta = $('[data-conf-add]', conf);
    const added = $('.conf__added', conf);
    const slotsEl = $('[data-slots]', conf);
    const empEl = $('[data-emp]', conf);
    let pack = (CONFIG.packs.find(x => x.available !== false) || { n: 1 }).n, emp = 1, slots = []; // slots[i] = { finder, place, qty, el }

    $('[data-packs]', conf).innerHTML = CONFIG.packs.map(p => {
      const full = p.n * CONFIG.product.unitPrice, save = Math.round((1 - p.price / full) * 100);
      return `
      <label class="offer">
        <input type="radio" name="pack" value="${p.n}" ${p.n === CONFIG.packs.find(x => x.available !== false)?.n ? 'checked' : ''} ${p.available === false ? 'disabled' : ''}>
        <span class="offer__img">${p.n > 1 ? `<i>×${p.n}</i>` : ''}<img src="${CONFIG.img.plaque}" alt="" width="600" height="614"></span>
        <span class="offer__txt"><b>${p.n} Plaque${p.n > 1 ? 's' : ''}</b>${save > 0 ? `<em>Économisez ${save} %</em><span>${euro(p.price / p.n)} la plaque</span>` : ''}</span>
        <span class="offer__price"><b>${euro(p.price)}</b></span>
        ${p.badge ? `<span class="offer__badge">${esc(p.badge)}</span>` : ''}
      </label>`;
    }).join('');

    const assigned = () => slots.reduce((n, s) => n + s.qty, 0);
    const ready = () => slots.every(s => s.place) && assigned() === pack;
    const sync = () => {
      cta.classList.toggle('is-waiting', !ready());
      slots.forEach(s => { if (s.dec) { s.dec.disabled = s.qty <= 1; s.inc.disabled = assigned() >= pack; s.out.textContent = `${s.qty} plaque${s.qty > 1 ? 's' : ''}`; } });
      const left = $('.conf__left', conf);
      if (left) left.textContent = emp > 1 ? `1 plaque par établissement (${pack} établissements)` : (pack > 1 ? `Les ${pack} plaques pour le même établissement` : '');
      if (ready()) err.hidden = true;
    };
    const renderEmp = () => {
      // comme Digifeel : toutes les plaques pour 1 établissement, ou 1 plaque par établissement
      empEl.innerHTML = [...new Set([1, pack])].map(k => `<option value="${k}">${k} Emplacement${k > 1 ? 's' : ''}</option>`).join('');
      if (emp !== 1 && emp !== pack) emp = 1; empEl.value = emp;
      empEl.disabled = pack === 1;
    };
    // répartit les plaques : 1 par emplacement, le reste sur le premier
    const split = () => slots.forEach(s => { s.qty = emp === 1 ? pack : 1; });
    const renderSlots = () => {
      slots.slice(emp).forEach(s => s.el.remove());
      slots = slots.slice(0, emp);
      for (let i = slots.length; i < emp; i++) {
        const el = document.createElement('div');
        el.className = 'conf__slot';
        el.innerHTML = `
          <div class="conf__slot-head" hidden><b>Emplacement ${i + 1}</b></div>
          <div data-finder data-g data-label="Emplacement ${i + 1}"></div>`;
        slotsEl.append(el);
        const s = { el, place: null, qty: 1 };
        s.finder = mountFinder($('[data-finder]', el), pl => { s.place = pl; added.hidden = true; sync(); });
        slots.push(s);
      }
      slots.forEach(s => { $('.conf__slot-head', s.el).hidden = emp === 1; });
      let left = $('.conf__left', conf);
      if (!left) { left = document.createElement('p'); left.className = 'conf__left'; slotsEl.after(left); }
      split(); sync();
    };

    conf.addEventListener('change', e => {
      if (e.target.name === 'pack') { pack = +e.target.value; renderEmp(); renderSlots(); }
      if (e.target === empEl) { emp = +empEl.value; renderSlots(); }
    });

    cta.addEventListener('click', () => {
      if (!ready()) {
        const missing = slots.find(s => !s.place);
        err.textContent = missing
          ? (emp > 1 ? 'Indiquez l’établissement de chaque emplacement.' : 'Indiquez votre établissement : votre plaque est reliée à sa fiche Google.')
          : `Répartissez vos ${pack} plaques entre vos emplacements (${assigned()} / ${pack}).`;
        err.hidden = false;
        missing && missing.finder.focus();
        return;
      }
      cta.disabled = true;
      addLine(pack, slots.flatMap(s => Array(s.qty).fill(s.place)))
        .then(() => {
          $('b', added).textContent = pack === 1 ? '1 plaque' : `Pack ${pack} plaques`;
          added.hidden = false;
          slots.forEach(s => { s.finder.reset(); s.place = null; });
          sync();
          openDrawer();
        })
        .catch(e => { err.textContent = `Ajout au panier impossible : ${e.message}`; err.hidden = false; })
        .finally(() => { cta.disabled = false; });
    });
    $('[data-conf-another]', conf).addEventListener('click', () => { closeDrawer(); added.hidden = true; slots[0] && slots[0].finder.focus(); });

    // offre demandée dans l'URL (?pack=3) et établissement choisi depuis l'accueil
    const askPack = +params.get('pack');
    if (packOf(askPack)) { $(`[name=pack][value="${askPack}"]`, conf).checked = true; pack = askPack; }
    renderEmp(); renderSlots();
    const fromHome = store.get(PICK, null, sessionStorage);
    if (fromHome) {
      store.del(PICK, sessionStorage);
      fromHome.prefillName ? slots[0].finder.prefill(fromHome.prefillName) : slots[0].finder.set(fromHome);
    }
    if (location.hash === '#commander') setTimeout(() => conf.scrollIntoView({ block: 'start' }), 300);
  }

  /* page plaque personnalisée : formulaire de devis avec recherche d'établissement */
  const perso = $('[data-perso]');
  if (perso) {
    const form = $('form', perso);
    mountFinder($('[data-finder]', perso), p => {
      $('[data-etab]', form).value = p ? `${p.name}${p.address ? ' — ' + p.address : ''}${p.placeId ? ' — ' + reviewUrl(p.placeId) : ''}` : '';
    });
  }

  /* sélecteurs de quantité sur la page */
  $$('[data-qty]').forEach(picker => {
    const input = $('input', picker);
    const dec = $('[data-dec]', picker), inc = $('[data-inc]', picker);
    const targets = $$(`[data-price-for="#${picker.id}"]`);
    const sync = () => {
      let n = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
      input.value = n; dec.disabled = n <= 1;
      targets.forEach(t => t.textContent = euro(n * CONFIG.product.unitPrice));
      const hint = $(`[data-network-hint="#${picker.id}"]`);
      if (hint) hint.hidden = n < CONFIG.networkThreshold;
    };
    dec.addEventListener('click', () => { input.value = +input.value - 1; sync(); });
    inc.addEventListener('click', () => { input.value = +input.value + 1; sync(); });
    input.addEventListener('change', sync);
    sync();
  });

  /* ------------------------------------------------------------------ barre d'achat mobile */
  const sticky = $('.sticky-buy');
  if (sticky) {
    const hideZones = $$('[data-hide-sticky]');
    const seen = new Map();
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => seen.set(e.target, e.isIntersecting));
      const anyVisible = [...seen.values()].some(Boolean);
      sticky.classList.toggle('is-visible', !anyVisible && scrollY > 200);
    }, { threshold: 0 });
    hideZones.forEach(z => { seen.set(z, true); io.observe(z); });
    addEventListener('scroll', () => {
      const anyVisible = [...seen.values()].some(Boolean);
      sticky.classList.toggle('is-visible', !anyVisible && scrollY > 200);
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ galerie page produit */
  const gallery = $('.gallery');
  const dots = $$('.gallery__dots button');
  if (gallery && dots.length) {
    const slides = [...gallery.children];
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio > .6) {
          const i = slides.indexOf(e.target);
          dots.forEach((d, j) => d.setAttribute('aria-current', String(i === j)));
        }
      });
    }, { root: gallery, threshold: .6 });
    slides.forEach(s => io.observe(s));
    dots.forEach((d, i) => d.addEventListener('click', () => gallery.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' })));
  }

  /* ------------------------------------------------------------------ formulaire pros */
  $$('[data-lead-form]').forEach(form => {
    const msg = $('.form__msg', form);
    const started = Date.now();
    form.addEventListener('submit', async e => {
      e.preventDefault();
      msg.className = 'form__msg';
      if (!form.reportValidity()) return;
      const data = Object.fromEntries(new FormData(form));
      if (form.dataset.leadForm) data.demande = form.dataset.leadForm;
      if (data.website || Date.now() - started < 2500) return; // anti-spam discret
      delete data.website;
      const show = (cls, text) => { msg.textContent = text; msg.className = `form__msg ${cls}`; };
      if (CONFIG.leadEndpoint) {
        try {
          const r = await fetch(CONFIG.leadEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
          if (!r.ok) throw new Error(r.status);
          form.reset();
          show('is-ok', form.dataset.leadOk || 'Merci. Nous revenons vers vous rapidement avec une proposition adaptée.');
        } catch {
          show('is-err', 'L’envoi n’a pas abouti. Réessayez dans un instant.');
        }
      } else if (CONFIG.contactEmail) {
        const body = Object.entries(data).map(([k, v]) => `${k} : ${v}`).join('\n');
        const subject = form.dataset.leadForm || 'Équiper mon réseau';
        location.href = `mailto:${CONFIG.contactEmail}?subject=${encodeURIComponent(subject + ' — ' + (data.societe || data.etablissement || ''))}&body=${encodeURIComponent(body)}`;
      } else {
        show('is-err', document.body.classList.contains('show-placeholders')
          ? 'Formulaire non connecté : renseigner leadEndpoint ou contactEmail dans assets/js/site.js.'
          : 'Le formulaire est momentanément indisponible.');
      }
    });
  });

  /* toast éventuel */
  window.__5ive = { CONFIG, addLine, openDrawer };
})();
